/**
 * Created by beyondin on 2018/7/27.
 */
import doctors from '@/view/doctors/index'
import doctorsDetail from '@/view/doctors/detail'
import doctorsReserve from '@/view/doctors/Reserve'
const route = [{
    path: '/doctors/:short_name'+'.html',
    meta: {
      title: ''
    },
    component: doctors
  },
  {
    path: '/doctorsDetail/:short_name'+'/:doctorId'+'.html',
    meta: {
      title: '医生详情'
    },
    component: doctorsDetail
  },
  {
    path:'/doctorsReserve/:short_name'+'/:hospital_id'+'/:sub_hospital_id'+'/:name'+'.html',
    meta: {
      title: '预约申请'
    },
    component: doctorsReserve
  }
];

export default route;



// WEBPACK FOOTER //
// ./src/router/branch/doctors.js